import { createSlice } from '@reduxjs/toolkit'
import { CLIENT_STATUS_ACTIVE } from 'data/enums/client-status-enum';

const initialState = {
  page: 1,
  pageSize: 20,
  statuses: [ CLIENT_STATUS_ACTIVE ]
}

const clientListFilterSlice = createSlice({
  name: 'clientListFilter',
  initialState: initialState,
  reducers: {
    changeSearchCriteria(state, action) {
      Object.keys(action.payload).forEach(key => {
        state[key] = action.payload[key];
      });
    },
    changePage(state, action) {
      state.page = action.payload;
    }
  },
})

export const { changeSearchCriteria, changePage } = clientListFilterSlice.actions
export default clientListFilterSlice.reducer
